import { styled } from "goober";

export const ResultSummary = styled("div")`
  flex-shrink: 0;
  padding: 12px;
  border: 0.5px solid var(--border-alpha);
  border-radius: 12px;
  background: var(--surface-secondary);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-height: 200px;
  overflow: auto;
`;
